/**
 * Popup (form): any link to #popup-<name> opens the matching [data-ef-popup]; close button, backdrop and Escape close it.
 * Focus moves into the dialog and back to the button on close. Clicks are caught in the capture phase: Divi's
 * smooth-scroll handler takes every #hash link whose target exists and stops the event before it reaches document.
 */
(() => {
  let opener = null;

  // Popups render inside <main>, whose stacking context sits under the fixed site header: move them to <body>.
  document.querySelectorAll('[data-ef-popup]').forEach((popup) => document.body.appendChild(popup));

  const open = (popup, trigger) => {
    opener = trigger;
    popup.hidden = false;
    document.documentElement.classList.add('has-ef-popup');
    popup.querySelector('.ef-popup__close')?.focus();
  };

  const close = (popup) => {
    popup.hidden = true;
    document.documentElement.classList.remove('has-ef-popup');
    opener?.focus();
    opener = null;
  };

  document.addEventListener('click', (event) => {
    const closer = event.target.closest('[data-ef-popup-close]');
    if (closer) {
      close(closer.closest('[data-ef-popup]'));
      return;
    }
    const link = event.target.closest('a[href*="#popup-"]');
    if (!link) {
      return;
    }
    const popup = document.getElementById(link.getAttribute('href').split('#')[1]);
    if (popup?.matches('[data-ef-popup]')) {
      event.preventDefault();
      event.stopPropagation();
      open(popup, link);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if ('Escape' !== event.key) {
      return;
    }
    const popup = document.querySelector('[data-ef-popup]:not([hidden])');
    if (popup) {
      close(popup);
    }
  });
})();
